import { computed, type ComputedRef, type Ref } from 'vue'

import type {
    QuestionnaireCompleteInput,
    QuestionnaireCompleteStepInput,
    QuestionnaireFragment,
} from '@/graphql/api'
import { isNotUndefinedOrNull } from '@/helpers'
import { useQuestionnaireStore } from './useQuestionnaireStore'

export function useQuestionnaireSubmit(
    questionnaire: Ref<QuestionnaireFragment>,
    sourceUrl: string
): ComputedRef<QuestionnaireCompleteInput> {
    const questionnaireStore = useQuestionnaireStore()

    return computed(
        (): QuestionnaireCompleteInput => ({
            referenceId: questionnaire.value.id,
            type: questionnaire.value.type,
            steps: Object.values(
                questionnaireStore.answers[questionnaire.value.id] || {}
            )
                .reduce((acc, answer) => {
                    acc[answer.stepIndex] = {
                        title: answer.stepTitle,
                        answers: [
                            ...(acc[answer.stepIndex]?.answers || []),
                            answer.answer,
                        ],
                    }

                    return acc
                }, [] as QuestionnaireCompleteStepInput[])
                .filter(isNotUndefinedOrNull),
            sourceUrl,
        })
    )
}
